module.exports = __webpack_public_path__ + "img/foto2.671ea8cd.jpg";